import type { Article } from '../types';
import whatAreTelegramStars from './what-are-telegram-stars';
import howToAccept from './how-to-accept-telegram-stars-payments';
import withdrawToTon from './withdraw-telegram-stars-to-ton';
import feesExplained from './telegram-stars-fees-explained';
import paymentLinks from './telegram-stars-payment-links';
import botApiGuide from './telegram-stars-bot-api-developer-guide';
import vsStripe from './telegram-stars-vs-stripe-paypal-crypto';
import sellDigital from './sell-digital-products-telegram-stars';
import priceUsdTon from './telegram-stars-price-usd-ton';
import refundsHold from './telegram-stars-refunds-21-day-hold';
import howToBuy from './how-to-buy-telegram-stars';
import telegramStarsPayment from './telegram-stars-payment';
import subscriptions from './telegram-stars-subscriptions';
import monetizeChannel from './monetize-telegram-channel-with-stars';
import deliverFiles from './deliver-files-with-telegram-stars';
import freelancers from './telegram-stars-for-freelancers';
import miniApp from './telegram-mini-app-stars-payments';
import priceProducts from './how-to-price-products-in-telegram-stars';

/** All published articles, newest first. */
export const articles: Article[] = [
  subscriptions,
  monetizeChannel,
  deliverFiles,
  freelancers,
  miniApp,
  priceProducts,
  telegramStarsPayment,
  howToBuy,
  refundsHold,
  priceUsdTon,
  sellDigital,
  vsStripe,
  botApiGuide,
  paymentLinks,
  feesExplained,
  withdrawToTon,
  howToAccept,
  whatAreTelegramStars,
].sort((a, b) => (a.datePublished < b.datePublished ? 1 : -1));

export const articleBySlug = (slug: string): Article | undefined => articles.find((a) => a.slug === slug);
